// Converts hours and minutes to decimal hours (e.g., 1h 30m => 1.5)
export function convertToDecimalHours(hours, minutes) {
    if (isNaN(hours) || isNaN(minutes)) {
        throw new Error("Invalid input: hours and minutes must be numbers.");
    }
    return parseFloat((hours + minutes / 60).toFixed(2));
}

// Converts decimal hours (e.g., 1.5) to { hours: 1, minutes: 30 }
export function convertFromDecimalHours(decimal) {
    if (isNaN(decimal)) {
        throw new Error("Invalid input: decimal must be a number.");
    }
    const hours = Math.floor(decimal);
    const minutes = Math.round((decimal - hours) * 60);
    return { hours, minutes };
}